import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import SmartFeedEngine from "SmartFeed/smart-feed-engine";

export const useCollectionItemFeedStore = defineSmartFeedPiniaStore("collection-item-feed-store", {
  state: () => ({
    visibility: "",
    collectionId: null,
    metadata: {
      // CollectionItemSmartFeed paginates descending by collection_item_id
      // (the controller's last_id default is PHP_INT_MAX). Seed the same
      // sentinel here so the FE's first request matches the source's expected
      // direction; otherwise last_id=0 returns no rows.
      lastId: Number.MAX_SAFE_INTEGER,
      collectionId: 0,
      itemId: 0,
      itemContext: "",
      hasItem: false,
    },
    smartFeedEngine: new SmartFeedEngine(),
  }),
  getters: {
    feedUrl() {
      const collectionId = this.collectionId || this.metadata.collectionId;
      return `/collection/${collectionId}/items`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        item_id: this.metadata.itemId,
        item_context: this.metadata.itemContext,
      };
    },
  },
});
